"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SeoManagerHelpers = require("../helpers/SeoManagerHelpers");

var _BaseSeoManager2 = _interopRequireDefault(require("../BaseSeoManager"));

var _CasaOldHelmetDataHelper = require("../helpers/CasaOldHelmetDataHelper");

var _Helmet = require("../meta/Helmet");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MANAGER_TYPE = _SeoManagerHelpers.HELPER_MANAGER_TYPE.IT;

var ImmotypeSeoManager = /*#__PURE__*/function (_BaseSeoManager) {
  _inherits(ImmotypeSeoManager, _BaseSeoManager);

  var _super = _createSuper(ImmotypeSeoManager);

  function ImmotypeSeoManager(domain, lang) {
    var _this;

    _classCallCheck(this, ImmotypeSeoManager);

    _this = _super.call(this, domain, lang);
    _this.num_levels = 0;
    _this.max_levels = 0;
    _this.level_prec = null;
    return _this;
  }

  _createClass(ImmotypeSeoManager, [{
    key: "decodeLevel",
    value: function decodeLevel(level, value) {
      if (!this.isValidDecode()) {
        return;
      }

      this.valid_levels["level".concat(level)] = true;
      this.level_prec = level === 1 ? null : this.data.seo_decode_type["level".concat(level - 1)];

      switch (level) {
        case 1:
          this.decodeLevel1(value);
          break;

        case 2:
          this.decodeLevel2(value, level);
          break;

        case 3:
          this.decodeLevel3(value, level);
          break;

        case 4:
          this.decodeLevel4(value, level);
          break;

        default:
          this.valid_levels.level5 = false;
          break;
      }

      if (level > this.max_levels && this.max_levels > 0) {
        this.valid_levels["level".concat(level)] = false;
      }
    }
  }, {
    key: "decodeLevel1",
    value: function decodeLevel1(value) {
      try {
        if (_SeoManagerHelpers.CAT_DECODE_FOR_ESAPI[this.lang][value]) {
          this.addData('category', value);
          this.addDecodeData('level1', 'category');
        } else {
          var imt = (0, _SeoManagerHelpers.getImmotype)(this.lang);
          var cat = (0, _SeoManagerHelpers.getCategoryImmotype)(this.lang, value);
          var obj = imt[cat.category] && imt[cat.category].children[cat.immotype] ? imt[cat.category].children[cat.immotype] : null;

          if (obj) {
            this.max_levels = 1;
            this.addData('propertyTypes', obj);
            this.addDecodeData('level1', 'propertyTypes');
          } else {
            this.data.seo_decode_type = {};
            this.valid_levels.level1 = false;
          }
        }
      } catch (error) {
        this.valid_levels.level1 = false;
      }
    }
  }, {
    key: "decodeLevel2",
    value: function decodeLevel2(value, level) {
      this.max_levels = 2;
      var rooms = (0, _SeoManagerHelpers.getRooms)(value);

      if (rooms) {
        this.addData('rooms', rooms);
        this.addDecodeData('level2', 'room');
      } else {
        var price = (0, _SeoManagerHelpers.getPrice)(value);

        if (price) {
          this.addData('price', price);
          this.addDecodeData('level2', 'price');
        } else {
          var publisher = (0, _SeoManagerHelpers.getPublisher)(value);

          if (publisher) {
            this.addData('publisher', publisher);
            this.addDecodeData('level2', 'publisher');
          } else {
            this.decodeGeo2(value, level);
          }
        }
      }
    }
  }, {
    key: "decodeLevel3",
    value: function decodeLevel3(value, level) {
      switch (this.level_prec) {
        case 'room':
        case 'price':
        case 'publisher':
          this.decodeGeo3(value, level);
          break;

        default:
          this.decodeAree(value, level);
          break;
      }
    }
  }, {
    key: "decodeLevel4",
    value: function decodeLevel4(value, level) {
      this.decodeAree(value, level);
    }
  }, {
    key: "decode",
    value: function decode(url) {
      return _get(_getPrototypeOf(ImmotypeSeoManager.prototype), "decode", this).call(this, url, MANAGER_TYPE);
    }
  }, {
    key: "decodeGeo2",
    value: function decodeGeo2(value, level) {
      this.max_levels = 2;
      return this.decodeGeo(value, level);
    }
  }, {
    key: "decodeGeo3",
    value: function decodeGeo3(value, level) {
      this.max_levels = 3;
      return this.decodeGeo(value, level);
    }
  }, {
    key: "decodeGeo",
    value: function decodeGeo(value, level) {
      var geoType = (0, _SeoManagerHelpers.decodeGeoType)(value, level);
      var geo = Object.assign({}, geoType.geo);
      var dgeo = Object.assign({}, geoType.dgeo);

      if (geo.type === 'city') {
        this.max_levels++;
      }

      this.addDecodeData("level".concat(level), geo.type);
      this.addData('geo', dgeo);

      if (geoType.valid_levels) {
        this.valid_levels = geoType.valid_levels;
      }

      return geo;
    }
  }, {
    key: "decodeAree",
    value: function decodeAree(value, level) {
      var dgeo = this.data.geo;
      var geo = (0, _SeoManagerHelpers.decodeAree)(value);
      dgeo.l10 = _defineProperty({}, geo.type, geo.level1);
      this.addDecodeData("level".concat(level), geo.type);
      this.addData('geo', dgeo);
      return geo;
    }
  }, {
    key: "createSeoData",
    value: function createSeoData() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          locations = _ref.locations,
          total_listings = _ref.total_listings,
          seoParams = _ref.seoParams,
          isSrpUrl = _ref.isSrpUrl;

      this.seo_data.seo = (0, _Helmet.getHelmet)({
        domain: this.domain,
        lang: this.lang,
        seodata: this.data,
        locations: locations,
        count: total_listings,
        seoParams: seoParams,
        pageType: 'ImmotypePage',
        isSrpUrl: isSrpUrl
      });
    }
  }, {
    key: "getImmoType",
    value: function getImmoType(t) {
      try {
        var label;

        switch (t) {
          case 'P':
            label = 'label_plural';
            break;

          default:
            label = 'label';
            break;
        }

        if (this.data.immotype && this.data.immotype[label]) {
          return this.data.immotype[label];
        }

        return '';
      } catch (e) {
        return '';
      }
    }
  }], [{
    key: "getLevel1Slug",
    value: function getLevel1Slug() {
      return {
        type: MANAGER_TYPE,
        regexp: (0, _SeoManagerHelpers.getImmotypeSlug)()
      };
    }
  }]);

  return ImmotypeSeoManager;
}(_BaseSeoManager2["default"]);

var _default = ImmotypeSeoManager;
exports["default"] = _default;